module.exports = __webpack_public_path__ + "static/img/14000606.0b6cb889.png";